import { Number, Partial, Record, Static, String } from "runtypes";

export const SportRuntype = Record({
  name: String,
}).And(
  Partial({
    id: Number,
  })
);

export interface ISportData extends Static<typeof SportRuntype> {}

export interface ISport extends ISportData {
  id: number;
}



// WEBPACK FOOTER //
// ./src/api/types/ISport.ts